import React from 'react';
import classNames from 'classnames';
import { Field } from 'react-final-form';
import { FormattedMessage } from 'react-intl';

import css from './PaymentMethodField.module.css';

const IconRadioButton = props => {
  const { className, checkedClassName, showAsRequired } = props;
  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        className={showAsRequired ? css.required : css.notChecked}
        cx="5"
        cy="19"
        r="6"
        transform="translate(2 -12)"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      />

      <g
        className={classNames(css.checked, checkedClassName || css.checkedStyle)}
        transform="translate(2 -12)"
        fill="none"
        fillRule="evenodd"
      >
        <circle strokeWidth="1" cx="5" cy="19" r="6" />
        <circle fill="#FFF" fillRule="nonzero" cx="5" cy="19" r="6" />
        <circle cx="5" cy="19" r="4" />
      </g>
    </svg>
  );
};

const PaymentMethodField = props => {
  const { className, isBestChoice, title, price, pricePer, descriptionList, id, ...rest } = props;

  const classes = classNames(css.root, className);
  const radioButtonProps = {
    id,
    className: css.input,
    component: 'input',
    type: 'radio',
    ...rest,
  };

  return (
    <div className={classes}>
      <Field {...radioButtonProps} />
      <label htmlFor={id} className={css.label}>
        <div className={css.title}>{title}</div>

        <div className={classNames(css.price, { [css.bestPrice]: isBestChoice })}>
          {price}
          {pricePer && <span className={css.pricePer}>{pricePer}</span>}
          {isBestChoice ? (
            <div className={css.bestChoice}>
              <FormattedMessage id="General.bestChoice" />
            </div>
          ) : null}
        </div>
        <span className={css.radioButtonWrapper}>
          <IconRadioButton className={css.radioButtonSvg} />
        </span>
        <ul className={css.descriptionList}>
          {descriptionList.map(des => (
            <li key={des} className={css.descriptionItem}>
              {des}
            </li>
          ))}
        </ul>
      </label>
    </div>
  );
};

export default PaymentMethodField;
